(function () {
  function point(stage, event) {
    var box = stage.getBoundingClientRect();
    return {
      x: ((event.clientX - box.left) / box.width) * 100,
      y: ((event.clientY - box.top) / box.height) * 100,
    };
  }

  function currentPos(stage, note) {
    if (note.style.left) {
      return {
        x: parseFloat(note.style.left) || 0,
        y: parseFloat(note.style.top) || 0,
      };
    }
    var s = stage.getBoundingClientRect();
    var n = note.getBoundingClientRect();
    return {
      x: ((n.left - s.left) / s.width) * 100,
      y: ((n.top - s.top) / s.height) * 100,
    };
  }

  function bind(root) {
    var stage = root.querySelector("[data-ftabs-stage]");
    if (!stage || root.getAttribute("data-ftabs-bound") === "true") return;
    root.setAttribute("data-ftabs-bound", "true");

    var dockBar = root.querySelector("[data-ftabs-dock-bar]");
    var dock = root.querySelector("[data-ftabs-dock]");
    var dockLabel = root.querySelector("[data-ftabs-dock-label]");
    var notes = Array.prototype.slice.call(root.querySelectorAll("[data-ftab]"));
    var drag = null;
    var front = 10;

    function emptyDock() {
      return !root.querySelector("[data-ftab].is-closed");
    }

    function setDock() {
      var empty = emptyDock();
      if (dockBar) {
        dockBar.hidden = empty;
        dockBar.classList.toggle("is-empty", empty);
      }
      if (dockLabel) {
        dockLabel.textContent = "Closed — click to put back";
        dockLabel.hidden = empty;
      }
    }

    function bringFront(note) {
      notes.forEach(function (item) {
        item.classList.remove("is-front");
      });
      note.classList.add("is-front");
      front += 1;
      note.style.zIndex = String(front);
    }

    notes.forEach(function (note, index) {
      note.style.zIndex = String(10 + index);
      var handle = note.querySelector("[data-ftab-drag]");
      var close = note.querySelector("[data-ftab-close]");
      if (handle) {
        handle.addEventListener("pointerdown", function (event) {
          event.preventDefault();
          var now = point(stage, event);
          var at = currentPos(stage, note);
          drag = { note: note, dx: now.x - at.x, dy: now.y - at.y };
          bringFront(note);
          if (handle.setPointerCapture) handle.setPointerCapture(event.pointerId);
        });
      }
      if (close) {
        close.addEventListener("click", function () {
          note.classList.add("is-closed");
          var btn = document.createElement("button");
          btn.type = "button";
          btn.textContent = note.getAttribute("data-title") || "Note";
          btn.setAttribute("data-restore", note.getAttribute("data-ftab"));
          btn.addEventListener("click", function () {
            note.classList.remove("is-closed");
            bringFront(note);
            btn.remove();
            setDock();
          });
          if (dock) dock.appendChild(btn);
          setDock();
        });
      }
    });

    function limits(note) {
      var box = stage.getBoundingClientRect();
      var maxX = Math.max(0, 100 - (note.offsetWidth / box.width) * 100);
      var maxY = Math.max(0, 100 - (note.offsetHeight / box.height) * 100);
      return { maxX: maxX, maxY: maxY };
    }

    function move(event) {
      if (!drag) return;
      event.preventDefault();
      var now = point(stage, event);
      var edge = limits(drag.note);
      drag.note.style.left = Math.min(edge.maxX, Math.max(0, now.x - drag.dx)) + "%";
      drag.note.style.top = Math.min(edge.maxY, Math.max(0, now.y - drag.dy)) + "%";
    }

    function stop() {
      drag = null;
    }

    window.addEventListener("pointermove", move, { passive: false });
    window.addEventListener("pointerup", stop);
    window.addEventListener("touchmove", function (event) {
      if (drag) event.preventDefault();
    }, { passive: false });
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", stop);

    root.querySelectorAll("[data-ftabs-reset]").forEach(function (button) {
      button.addEventListener("click", function () {
        notes.forEach(function (note) {
          note.classList.remove("is-closed", "is-front");
          note.style.left = "";
          note.style.top = "";
          note.style.transform = "";
        });
        if (dock) {
          Array.prototype.slice.call(dock.querySelectorAll("[data-restore]")).forEach(function (btn) {
            btn.remove();
          });
        }
        setDock();
      });
    });

    setDock();
  }

  function start() {
    document.querySelectorAll("[data-ftabs]").forEach(bind);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  document.addEventListener("shopify:section:load", start);
})();
